import { render } from "./addSellReq.vue?vue&type=template&id=720debfb&scoped=true"
import script from "./addSellReq.vue?vue&type=script&lang=js"
export * from "./addSellReq.vue?vue&type=script&lang=js"

import "./addSellReq.vue?vue&type=style&index=0&id=720debfb&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-720debfb"]])

export default __exports__